/**
 * Ofuscación Base64 del enlace de login
 * Compatible con Shopify Horizon y Cart Drawer dinámico.
 */

(function () {
  function redirectToLogin(element) {
    try {
      const encodedUrl = element.dataset.url;
      if (!encodedUrl) return;

      const decodedUrl = atob(encodedUrl);

      // Solo permitir rutas internas
      if (!decodedUrl.startsWith('/account/')) return;

      window.location.assign(decodedUrl);
    } catch (error) {
      console.error('Error al decodificar el enlace:', error);
    }
  }

  document.addEventListener('click', function (event) {
    const element = event.target.closest('.cart-login-obfuscated');
    if (!element) return;

    event.preventDefault();
    redirectToLogin(element);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const element = event.target.closest('.cart-login-obfuscated');
    if (!element) return;

    event.preventDefault();
    redirectToLogin(element);
  });
})();